module.exports = __webpack_public_path__ + "static/img/6.85e454b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/6.png
// module id = EASf
// module chunks = 1